<template>
  <div>
    <div class="card" style="max-width: 100%">
      <div class="card-header">
        <b>{{ title }} Municipio</b>
      </div>
      <div class="card-body text-dark">
        <router-link to="/configuracion" class="btn btn-info"
          ><i class="mdi mdi-undo-variant"></i> Regresar</router-link
        ><br /><br />

        <form @submit.prevent="saveMunicipio">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-sm-4">
                  <label>Código Municipio</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="municipio.codmun"
                    :disabled="disabled"
                    required
                  />
                </div>
                <div class="form-group col-sm-4">
                  <label>Nombre Municipio</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="municipio.municipio"
                    :disabled="disabled"
                    required
                  />
                </div>
                <div class="form-group col-sm-4">
                  <label>Departamento</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="municipio.departamento"
                    :disabled="disabled"
                    required
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label>Latitud</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="municipio.latitud"
                    :disabled="disabled"
                    required
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label>Longitud</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="municipio.longitud"
                    :disabled="disabled"
                    required
                  />
                </div>
                <div class="form-group col-sm-12">
                  <center>
                    <button
                      type="submit"
                      class="btn btn-success"
                      :disabled="disabled"
                    >
                      Guardar
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { headers } from "../../../api/headers";
import { configApi } from "../../../api/configApi";
export default {
  name: "municipios_crear",
  data: () => ({
    disabled: false,
    id_menu: 2,
    title: "Crear",
    municipio: {
      codmun: "",
      municipio: "",
      departamento: "",
      latitud: "",
      longitud: "",
    },
  }),
  mounted() {
    this.getDatosMunicipio();
  },
  computed: {},
  methods: {
    async getDatosMunicipio() {
      if (this.$route.params.id > 0) {
        return await this.axios
          .get(
            configApi + "configuracion/municipios/" + this.$route.params.id,
            { headers }
          )
          .then((response) => {
            this.municipio.codmun = response.data.data[0].codmun;
            this.municipio.municipio = response.data.data[0].municipio;
            this.municipio.departamento = response.data.data[0].departamento;
            this.municipio.latitud = response.data.data[0].latitud;
            this.municipio.longitud = response.data.data[0].longitud;

            if (this.$route.params.id > 0 && this.$route.params.accion == 0) {
              this.disabled = false;
              this.title = "Editar";
            }
          });
      }
    },
    async saveMunicipio() {
      if (this.$route.params.id > 0 && this.$route.params.accion == 0) {
        return await this.axios
          .put(
            configApi + "configuracion/municipios/" + this.$route.params.id,
            this.municipio,
            { headers }
          )
          .then((response) => {
            this.getDatosMunicipio();
            this.$Fun.alertaAccion("success", response.data.message, false);
          });
      } else {
        return await this.axios
          .post(configApi + "configuracion/municipios", this.municipio, {
            headers,
          })
          .then((response) => {
            this.resetForm();
            this.$Fun.alertaAccion("success", response.data.message, false);
          });
      }
    },
    resetForm() {
      this.municipio.codmun = "";
      this.municipio.municipio = "";
      this.municipio.departamento = "";
      this.municipio.codpais = "";
      this.municipio.latitud = "";
      this.municipio.longitud = "";
    },
  },
};
</script>
